import JWT from 'jsonwebtoken'

const setCurrentPage = (page) => {
    localStorage.setItem("pageBpc", JSON.stringify(page));
}

const getCurrentPage = () => {
    return JSON.parse(localStorage.getItem("pageBpc"));
}

const setCurrentPerm = (perm) => {
    localStorage.setItem("permBpc", JSON.stringify(perm));
}

const getCurrentPerm = () => {
    return JSON.parse(localStorage.getItem("permBpc"));
}

const setUserProfile = (responseJWT) => {
    localStorage.setItem("keyBpc", responseJWT);
}

const getDefaultPage = () => {
    let responseJWT = localStorage.getItem("keyBpc");
    let jwtResult = JWT.decode(responseJWT);
    if (!jwtResult) return {};
    return JSON.parse(jwtResult.user_token).defaultPage;
}

const getMenu = () => {
    let responseJWT = localStorage.getItem("keyBpc");
    let jwtResult = JWT.decode(responseJWT);
    if (!jwtResult) return {};
    return JSON.parse(jwtResult.user_token).menu;
}

const getUsername = () => {
    let responseJWT = localStorage.getItem("keyBpc");
    let jwtResult = JWT.decode(responseJWT);
    if (!jwtResult) return "";
    return jwtResult.iss;
}

const getUserBranch = () => {
    let responseJWT = localStorage.getItem("keyBpc");
    let jwtResult = JWT.decode(responseJWT);
    if (!jwtResult) return {};
    return JSON.parse(jwtResult.user_token).branch;
}


const clearSession = () => {
    localStorage.removeItem("keyBpc");
}

const isValidSession = () => {
    let key = localStorage.getItem("keyBpc");
    return (key && key !== '' && 0 !== key.length);
}

const formatDate = (date) => {
    if (!date) return null;

    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
}
const parseDate = (date) => {
    if (!date) return null;
    if (date.indexOf("-") > 0) return date;
    try {
        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    } catch (e) {
        return null;
    }
}

export {
    isValidSession,
    clearSession,
    setUserProfile,
    getMenu,
    getUsername,
    setCurrentPerm,
    getCurrentPerm,
    getUserBranch,
    formatDate,
    parseDate,
    setCurrentPage,
    getCurrentPage,
    getDefaultPage
}